export default __webpack_public_path__ + "static/media/2CAD.bc3421de.svg";